<template>

<v-dialog v-model="dialog" width="700px">
  <v-card>
    <p class=".title ma-2">Send NEW Documents to Host(s). ( It may take a few minutes before the mails are send )</p>
    <v-form ref="huovSendDocuHost">

    <v-textarea v-model="huov.mail_text" :rows="5" label="Optional text in the header of the email"></v-textarea> 

    <v-simple-table>
      <template v-slot:default>
       <tbody>
        <tr v-for="(docu,i) in huov.docu" :key="i"> 
          <td>
            <v-checkbox v-model="docu.docu_selected" :label="docu.docu_oms"></v-checkbox>
          </td> 
        </tr>
       </tbody>
      </template>
    </v-simple-table>  


    </v-form>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="primary mx-2"  small @click="updSendDocuHost">Send document(s)</v-btn>
      <v-btn color="primary"  small @click="dialog = false">Close</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
</template>

<script>
export default {
  data() { 
    return {
      dialog: false,
      huov_encrid: null,
      huov: {},
      huov_aant_volwRules: [
          v => (v && parseInt(v) >= 1) || "Number of Adults minimal 1"
      ]
    }
  },
  methods: {
    open(huov_encrid) {

      this.huov = {};

      this.$emit("showSnackbar");
      this.dialog = true;
      this.$axios
        .post("ares/json/ares/huov/getHuovSendDocuHost.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getHuovSendDocuHost"
          },
          getHuovSendDocuHost: {
            huov_encrid: huov_encrid
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.huov = res.data.getHuovSendDocuHost;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    updSendDocuHost() { 
      this.$axios
        .post("ares/json/ares/huov/updSendDocuHost.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "updSendDocuHost"
          },
          updSendDocuHost: {
            huov_encrid: this.huov.huov_encrid,
            mail_text: this.huov.mail_text,
            docu: this.huov.docu
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          }  else {      
             this.$store.dispatch('setSnackbar', {
              showing: true,
              text: res.data.updSendDocuHost.text,
              color: res.data.updSendDocuHost.color
             });
            this.dialog = false;
          }
        })
    },
  }
}
</script>

